'use client';
import { useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

import { usePageTransition } from '1_components/Transitition/Transitions';

export const useRedirectWithAnimation = () => {
  const { navigate } = usePageTransition();
  const searchParams = useSearchParams();

  const push = useCallback(
    (url: string) => {
      const existingParams = new URLSearchParams(searchParams.toString());
      const baseUrl = url.split('?')[0];
      const newUrl = `${baseUrl}?${existingParams.toString()}`;

      navigate(newUrl);
    },
    [navigate, searchParams]
  );

  return { push };
};
